import React, { lazy } from "react";
import { useLanguage } from "../LanguageContext";
import Seo from "../components/Seo";
import { getMeta } from "../seo/seoMeta";
import { organizationSchema, softwareSchema, webSiteSchema, faqSchema, siteNavigationSchema } from "../seo/seoConfig";
import { CLIENTS } from "../mock";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import LazySection from "../components/LazySection";
import { Toaster } from "../components/ui/toaster";
import LazyContact from "../components/LazyContact";

// Secciones debajo del hero: chunks separados, montados al acercarse (menos JS en la carga inicial).
const CaseSpotlight = lazy(() => import("../components/CaseSpotlight"));
const ClientsCarousel = lazy(() => import("../components/ClientsCarousel"));
const Modules = lazy(() => import("../components/Modules"));
const RegionalReach = lazy(() => import("../components/RegionalReach"));
const ResultsSection = lazy(() => import("../components/ResultsSection"));
const Security = lazy(() => import("../components/Security"));
const VeevaPartner = lazy(() => import("../components/VeevaPartner"));
const Resources = lazy(() => import("../components/Resources"));
const FAQ = lazy(() => import("../components/FAQ"));
const Footer = lazy(() => import("../components/Footer"));

export default function Home() {
  const { lang, t } = useLanguage();
  const meta = getMeta(lang, "home");
  const homeFaqs = t.faq.items.slice(0, 5);
  const clientsSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Centros de investigación clínica que confían en Brainmart MED CT",
    itemListElement: CLIENTS.map((name, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: { "@type": "Organization", name },
    })),
  };
  return (
    <div className="min-h-screen bg-white text-[#1E293B]">
      <Seo
        title={meta.title}
        description={meta.description}
        path="/"
        schema={[organizationSchema(), softwareSchema(), webSiteSchema(), siteNavigationSchema(lang), faqSchema(homeFaqs), clientsSchema]}
      />
      <Navbar />
      <main>
        <Hero />
        <LazySection id="case-spotlight" minHeight={700}><CaseSpotlight /></LazySection>
        <LazySection minHeight={300}><ClientsCarousel /></LazySection>
        <LazySection id="modules" minHeight={1200}><Modules /></LazySection>
        <LazySection minHeight={900}><RegionalReach /></LazySection>
        <LazySection id="results" minHeight={900}><ResultsSection /></LazySection>
        <LazySection id="compliance" minHeight={1000}><Security /></LazySection>
        <LazySection minHeight={400}><VeevaPartner /></LazySection>
        <LazySection id="resources" minHeight={700}><Resources /></LazySection>
        <LazySection id="faq" minHeight={900}><FAQ /></LazySection>
        <LazyContact />
      </main>
      <LazySection minHeight={400}><Footer /></LazySection>
      <Toaster />
    </div>
  );
}
